import { PageHead, Section } from '../components/Shell';

interface Props {
  readonly kind: 'subscriptions' | 'email';
}

/**
 * Two sections the console is shaped for and the product does not yet have.
 * They are here rather than absent so the operator sees where each thing
 * stands, and so that when either arrives it has a door already on the nav.
 */
export const NotYet = ({ kind }: Props) =>
  kind === 'subscriptions' ? (
    <>
      <PageHead
        eyebrow="Subscriptions"
        title="Nothing to show yet"
        lede="Billing is a proposal, not a feature: nothing in the deployment charges anybody, and there is no subscriptions table to read."
      />
      <Section title="Where it stands">
        <p>
          The model is written up in <code>docs/circles.md</code>: one Stripe subscription per account with a
          quantity of circles, a 14-day trial gating circle creation, and a 30-day grace period before a lapsed
          circle goes dormant. When that lands, this page reads the <code>subscriptions</code> table the
          webhook writes — status, circle count, period end, Stripe ids — and links each row to the account
          and the circles it pays for.
        </p>
      </Section>
    </>
  ) : (
    <>
      <PageHead
        eyebrow="Email"
        title="Nothing has been sent"
        lede="No mail sender is wired up. Sign-up sends nothing, there is no password reset by email, and invites travel as links people share themselves."
      />
      <Section title="Where it stands">
        <p>
          Until a sender exists, a forgotten password is handled here: open the account and use{' '}
          <strong>Reset password</strong>, which sets a temporary one to read to the person and signs them
          out everywhere. When a sender arrives, every message it sends should be logged to a table this page
          can read — recipient, template, sent time, delivery result — and password reset should move to a
          single-use token by email.
        </p>
      </Section>
    </>
  );
